import { z } from 'zod';

export const ReportPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().min(1, 'Status is required'),
  period_end_date: z.string().date(),
  sent_date: z.string().date().optional(),
});

export type ReportProps = z.infer<typeof ReportPropsSchema>;
